<template>
    <div>
        <div class="main-container">
            <div>
                <Header
                        ref="header"
                        @refreshShared="refreshShared"
                        @setActiveTabs="setActiveTabs"
                        @setProjectRowDataInput="setProjectRowDataInput"
                        @setProjectTaskRowDataInput="setProjectTaskRowDataInput"
                        @rerenderMainLayout="rerenderMainLayout"
                        @refreshTreeAfterDeleteTimer="refreshTreeAfterDeleteTimer"
                        @refreshExpensePageFromHeader="refreshExpensePageFromHeader"
                        @refreshCashAdvanceFromHeader="refreshCashAdvanceFromHeader"
                        @refreshUserExpensePageFromHeader="refreshUserExpensePageFromHeader"
                        @setSharedTask="setSharedTask"
                        @refreshPurchase="refreshPurchase"
                        @refreshVendorInvoiceRequest="refreshVendorInvoiceRequest"
                        @selectCreatedTask="selectCreatedTask"
                        @setWorkDay="setWorkDay"/>
            </div>
            <div class="main-container_wrap">
<!--                <sideBar class="sidebar-container" />-->
                <app-main ref="appMain" @closeChat2="closeChat2" class="app-main" :class="{sbOpen: sidebarOpened}" @rerenderMainLayout="rerenderMainLayout" :key="appMainKey"/>
            </div>
        </div>
        <v-idle
                v-show="false"
                @idle="onidle"
                @remind="onremind"
                :loop="false"
                :reminders="[5, 10, 15]"
                :duration="sessionDuration" />
        <el-dialog
                :title="modalTitle"
                :visible.sync="dialogVisible"
                width="40%"
                :before-close="handleSessionModalClose">
            <span>{{$t('modal_sessionTimeout_sessionExpired_message')}}</span>
            <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="handleSessionModalClose">{{$t('general_ok')}}</el-button>
          </span>
        </el-dialog>
        <!--<message-timeout-modal/>-->
    </div>
</template>
<script>
  import axios from 'axios'
  import log from '@/log/log.js'
  import { Header, SideBar, AppMain } from './components'
  // import MessageTimeoutModal from "./components/messageTimeoutModal/index";
  // import { countSessionInterval } from '../mixins/sessionChecker'
  // import { countSessionTimeoutInterval } from '../mixins/sessionTimeoutChecker'
  export default {
    name: 'Layout',
    components: {
      // MessageTimeoutModal,
      Header,
      SideBar,
      AppMain
    },
    computed: {
      sidebarOpened() {
        return this.$store.state.sidebar.opened
      },
    },
    mixins: [
    ],
    data(){
      return{
        appMainKey:0,
        sessionDuration: 1800,
        dialogVisible: false,
        modalTitle: ''
      }
    },
    created() {
      if (sessionStorage.getItem('timer')) {
        this.sessionDuration = Number(sessionStorage.getItem('timer'))
      }
    },
    mounted(){

    },
    methods: {
        rerenderMainLayout(){
            this.appMainKey += 1
        },
      //PUT NOTIFICATION
      // setShared2(projectId, state, taskId, companyId, sharedProjecttaskNoteId, companyName){
      //   console.log('projectId, state, taskId, companyId, sharedProjecttaskNoteId, companyName', projectId, state, taskId, companyId, sharedProjecttaskNoteId, companyName)
      //   this.$refs.appMain.setShared2(projectId, state, taskId, companyId, sharedProjecttaskNoteId, companyName)
      // },
      //OPEN CHAT
      openDialog(){
        this.$refs.appMain.openChat2()
      },
      //CLOSE CHAT
      closeChat2(){
        this.$refs.header.closeChat2()
      },
      // REFRESH PROJECT PAGE AFTER ACCEPT SHARE TASK
      refreshShared(){
        // PROJECT PAGE
        if(this.$route.name === 'projects'){
          this.$refs.appMain.refreshSharedProject()
        }
      },
      refreshPurchase(){
        this.$refs.appMain.refreshPurchase()
      },
      refreshVendorInvoiceRequest(){
        this.$refs.appMain.refreshVendorInvoiceRequest()
      },
      //SET PROJECT/BU/ENG ROW DATA
      setProjectRowDataInput(projectId){
        this.$refs.appMain.setProjectRowDataInput(projectId)
      },
      //SET PROJECTTASK/BU/ENG ROW DATA
      setProjectTaskRowDataInput(projectId, state, taskId){
        this.$refs.appMain.setProjectTaskRowDataInput(projectId, state, taskId)
      },
      //SELECT FIRST TAB
      setActiveTabs(notificationType, stateId){
          return new Promise (async (resolve, reject) => {
            try {
              const data = {
                notificationType: notificationType,
                stateId: stateId
              };
              const tabSelect = await this.$refs.appMain.setActiveTabs(data);
              resolve(tabSelect)
            } catch (err){
              console.log(err);
              reject(err)
            }
          });
      },
      selectCreatedTask(taskId) {
          return new Promise (async (resolve, reject) => {
            try {
              const selectedNode = await this.$refs.appMain.selectCreatedTask(taskId);
              resolve(selectedNode)
            } catch (err){
              console.log(err);
              reject(err)
            }
          })
      },
      //REFRESH TREE AFTER DELETE TIMER
      refreshTreeAfterDeleteTimer(parentId, taskId){
        this.$refs.appMain.refreshTreeAfterDeleteTimer(parentId, taskId)
      },
      //REFRESH EXPENSE PAGE AFTER APPROVE OR REJECT FROM HEADER
      refreshExpensePageFromHeader(){
          this.$refs.appMain.refreshExpensePageFromHeader()
      },
      //REFRESH CASH ADVANCE PAGE AFTER APPROVE OR REJECT FROM HEADER
      refreshCashAdvanceFromHeader(){
          this.$refs.appMain.refreshCashAdvanceFromHeader()
      },
      //REFRESH USER PAGE EXPANSE AFTER APPROVE OR REJECT FROM HEADER
      refreshUserExpensePageFromHeader(){
          this.$refs.appMain.refreshUserExpensePageFromHeader()
      },
      //SET SHARED TASK IN SHARED PROJECT PAGE
      setSharedTask(){
          this.$refs.appMain.setSharedTask()
      },
      onidle() {
        this.modalTitle = this.$t('modal_sessionTimeout_sessionExpired_title');
        this.dialogVisible = true;
        // this.$alert(this.$t('modal_sessionTimeout_sessionExpired'), this.$t('modal_sessionTimeout_timeoutNotification'), {
        //   confirmButtonText: this.$t('general_ok'),
        //   callback: action => {
        //     this.$socket.close();
        //     sessionStorage.removeItem('token');
        //     sessionStorage.removeItem('vue-session-key');
        //     sessionStorage.removeItem('timer');
        //     localStorage.removeItem('selectedProjectId');
        //     localStorage.removeItem('companyId');
        //     // this.$session.destroy();
        //     this.$router.push(`/login?redirect=${this.$route.fullPath}`);
        //   }
        // })
      },
      handleSessionModalClose() {
        this.modalTitle = '';
        this.dialogVisible = false;
        this.$socket.close();
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('vue-session-key');
        sessionStorage.removeItem('timer');
        localStorage.removeItem('selectedProjectId');
        localStorage.removeItem('companyId');
        // this.$session.destroy();
        this.$router.push(`/login?redirect=${this.$route.fullPath}`);
      },
      onremind(time) {

        axios.post(`/api/v1/auth/logout`)
        .then(response => {

        })
        .catch(error => {

        })

        // Log logout
        log(`/api/v1/logs/create?companyId=${this.$route.query.companyId}`, {
          'action': 'log_timeout_logout',
          'paramsLog': {}
        })
        // alert seconds remaining to 00:00
        this.$message({
          type: 'info',
          message: `${this.$t('modal_sessionTimeout_sessionExpiresIn')} ${ time } ${this.$t('modal_sessionTimeout_seconds')}`
        });
      },
      setWorkDay() {
        this.$refs.appMain.setWorkDay()
      }
    },
    beforeDestroy(){
      console.log("DESTROY Layout")
      console.log('this', this)
      // this.notificationDisc("Error", "Connection Lost.", "error", 1000)
    },
  }
</script>

<style lang="scss" scoped>
    .main-container{
        /*display:flex;*/
        &_wrap{
            display:flex;
            .sidebar-container{
                position: fixed;
                margin-top:50px;
            }
        }
        .app-main{
            transition: all 500ms ease-out, transform 500ms ease-out;
        }
        /*.sbOpen{*/
        /*  margin-left:260px;*/
        /*  width: calc(100% - 260px);*/
        /*}*/
    }
</style>
